import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import AddTransaction from '../Routes/AddTransaction.js'
import ViewTransactionHistory from './ViewTransactionHistory.js'
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import '../Styles/RegistrationDetails.scss';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";


function RegistrationDetails({ registrationInfo, setViewRegistrationVisibility }) {
   console.log("registration info", registrationInfo)

   const [personalInfoVisibility, setPersonalInfoVisibility] = useState(true)
   const [emergencyContactVisibility, setEmergencyContactVisibility] = useState(false)
   const [medicalInfoVisibility, setMedicalInfoVisibility] = useState(false)
   const [insuranceInfoVisibility, setInsuranceInfoVisibility] = useState(false)
   const [weekInfoVisibility, setWeekInfoVisibility] = useState(false)
   const birthDate = DateHelpers.determineCamperAgeInYears(registrationInfo.birth_date)
   return (

      <div className="RegistrationDetailsContainer">
         <div className="RegistrationDetailsContent">
            <div className="RegistrationDetailsHeading">
               Registration Details
            </div>
            <div className="RegistrationDetailsInformation">
               <div className="RegistrationDetailsPersonalInformation">
                  <div className="RegistrationDetailsPersonalInformationHeading" onClick={() => setPersonalInfoVisibility(!personalInfoVisibility)}>
                     Personal Information
                  </div>
                  {personalInfoVisibility === true &&
                     <div className="RegistrationDetailsPersonalInformationFields">
                        <div className="RegistrationDetailsName">
                           Name: {registrationInfo.first_name + " " + registrationInfo.last_name}
                        </div>
                        <div className="RegistrationDetailsGender">
                           Gender:
                           {registrationInfo.gender === "M" &&
                              " Male"
                           }
                           {registrationInfo.gender === "F" &&
                              " Female"
                           }
                        </div>
                        <div className="RegistrationDetailsAge">
                           Age: {birthDate}
                        </div>
                        <div className="RegistrationDetailsAddressCityStateZip">
                           Address: {registrationInfo.mail_addr_1} {registrationInfo.mail_city}, {registrationInfo.mail_state} {registrationInfo.mail_zip}
                        </div>
                        <div className="RegistrationDetailsPhone">
                           Phone Number: {registrationInfo.phone_num}
                        </div>
                        <div className="RegistrationDetailsEmail">
                           Email Address: {registrationInfo.email_address}
                        </div>
                     </div>
                  }

               </div>
               <div className="RegistrationDetailsEmergencyContactInformation">
                  <div className="RegistrationDetailsEmergencyContactInformationHeading" onClick={() => setEmergencyContactVisibility(!emergencyContactVisibility)}>
                     Emergency Contact Information
                  </div>
                  {emergencyContactVisibility === true &&
                     <div className="RegistrationDetailsEmergencyContactInformationFields">
                        <div className="RegistrationDetailsEmergencyContactName">
                           Name: {registrationInfo.emergency_cont_name}
                        </div>
                        <div className="RegistrationDetailsEmergencyContactRelationship">
                           Relationship: {registrationInfo.emergency_cont_rel}
                        </div>
                        <div className="RegistrationDetailsEmergencyContactPhone">
                           Phone: {registrationInfo.emergency_cont_num}
                        </div>
                     </div>
                  }
               </div>
               <div className="RegistrationDetailsMedicalInformation">
                  <div className="RegistrationDetailsMedicalInformationHeading" onClick={() => setMedicalInfoVisibility(!medicalInfoVisibility)}>
                     Medical Information
                  </div>
                  {medicalInfoVisibility === true &&
                     <div className="RegistrationDetailsMedicalInformationFields">
                        <div className="RegistrationDetailsPreexistingConditionsCheckBoxesHasAsthma">
                           Has Asthma: {registrationInfo.has_asthma ? "Yes" : "No"}
                        </div>
                        <div className="RegistrationDetailsPreexistingConditionsCheckBoxesHasDiabetesOrHypoGlycemia">
                           Has Diabetes of Hypoglycemia: {registrationInfo.has_diab_or_hypgly ? "Yes" : "No"}
                        </div>
                        <div className="RegistrationDetailsPreexistingConditionsCheckBoxesHasEnvAllergies">
                           Has Environmental Allergies: {registrationInfo.has_env_allergies ? "Yes" : "No"}
                        </div>
                        <div className="RegistrationDetailsPreexistingConditionsCheckBoxesHasEpilepsy">
                           Has Epilepsy: {registrationInfo.has_epilepsy ? "Yes" : "No"}
                        </div>
                        <div className="RegistrationDetailsPreexistingConditionsCheckBoxesHasHeartCondition" >
                           Has Heart Condition: {registrationInfo.has_heart_condition ? "Yes" : "No"}
                        </div>
                        <div className="RegistrationDetailsPreexistingConditionsCheckBoxesHasHighBloodPressure">
                           Has High Blood Pressure: {registrationInfo.high_bld_press ? "Yes" : "No"}
                        </div>
                        <div className="RegistrationDetailsPreexistingConditionsCheckBoxesHasLupus">
                           Has Lupus: {registrationInfo.has_lupus ? "Yes" : "No"}
                        </div>
                        <div className="RegistrationDetailsPreexistingConditionsCheckBoxesHeatProblem" >
                           Heat Problem: {registrationInfo.has_heat_problem ? "Yes" : "No"}
                        </div>
                        <div className="RegistrationDetailsPreexistingConditionsCheckBoxesThyroidProblem">
                           Thyroid Problem: {registrationInfo.has_thyroid_problem ? "Yes" : "No"}
                        </div>
                        <div className="RegistrationDetailsDrugAllergyName">
                           Drug Allergy Name: {registrationInfo.drug_allergy_name === "" ? "None" : registrationInfo.drug_allergy_name}
                        </div>
                        <div className="RegistrationDetailsDrugAllergyEmergencyActionTaken">
                           Emergency Action Taken: {registrationInfo.drug_allergy_emergency_action === "" ? "None" : registrationInfo.drug_allergy_emergency_action}
                        </div>
                        <div className="RegistrationDetailsFoodAllergyName">
                           Food Allergy Name: {registrationInfo.food_allergy_name === "" ? "None" : registrationInfo.food_allergy_name}
                        </div>
                        <div className="RegistrationDetailsFoodAllergyEmergencyAction">
                           Emergency Action Taken: {registrationInfo.food_allergy_emergency_action === "" ? "None" : registrationInfo.food_allergy_emergency_action}
                        </div>
                        <div className="RegistrationDetailsOtherAllergyName">
                           Other Allergy Name: {registrationInfo.other_allergy_name === "" ? "None" : registrationInfo.other_allergy_name}
                        </div>
                        <div className="RegistrationDetailsOtherAllergyEmergencyAction">
                           Emergency Action Taken: {registrationInfo.food_other_allergy_emergency_action === "" ? "None" : registrationInfo.other_allergy_emergency_action}
                        </div>
                        <div className="RegistrationDetailsMedicationName">
                           Medication Name: {registrationInfo.medication_name === "" ? "None" : registrationInfo.medication_name}
                        </div>
                        <div className="RegistrationDetailsMedicationDose">
                           Medication Dose: {registrationInfo.medication_dose === "" ? "None" : registrationInfo.medication_dose}
                        </div>
                        <div className="LastTetanusShotDate">
                           Date of Last Tetanus Shot: {DateHelpers.getDisplayDate(registrationInfo.last_tetanus_shot_dt)}
                        </div>
                     </div>
                  }
               </div>
               <div className="RegistrationDetailsInsuranceInformation">
                  <div className="RegistrationDetailsInsuranceInformationHeading" onClick={() => setInsuranceInfoVisibility(!insuranceInfoVisibility)}>
                     Insurance Information
                  </div>
                  {insuranceInfoVisibility === true &&
                     <div className="RegistrationDetailsInsuranceInformationFields">
                        <div className="RegistrationDetailsInsuranceCompany">
                           Insurance Company: {registrationInfo.insurance_cmpy}
                        </div>
                        <div className="RegistrationDetailsInsuranceIdNumber">
                           ID Number:  {registrationInfo.insurance_id_num}
                        </div>
                        <div className="RegistrationDetailsGroupPolicyNumber">
                           Group Policy Number: {registrationInfo.insurance_group_num}
                        </div>
                        <div className="RegistrationDetailsPolicyHolderName">
                           Name of Policy Holder: {registrationInfo.policy_holder_name}
                        </div>
                        <div className="RegistrationDetailsPolicyHolderBirthdate">
                           Birthdate of Policy Holder: {registrationInfo.policy_holder_bd === null? "" : DateHelpers.getDisplayDate(registrationInfo.policy_holder_bd)}
                        </div>
                     </div>
                  }
               </div>
               <div className="RegistrationDetailsWeekInformation">
                  <div className="RegistrationDetailsWeekInformationHeading" onClick={() => setWeekInfoVisibility(!weekInfoVisibility)}>
                     Week Details
                  </div>
                  {weekInfoVisibility === true &&
                     <div className="RegistrationDetailsWeekInformationFields">

                        <div className="RegistrationDetailsEventName">
                           Event: {registrationInfo.camp_name}
                        </div>
                        <div className="RegistrationDetailsEventDates">
                           Dates: {DateHelpers.getEventDateRange(registrationInfo.begin_date, registrationInfo.end_date)}
                        </div>

                        {registrationInfo.camp_type === "Day Camp" &&
                           <div>
                              <div className="RegistrationDetailsDayCampBuddyDetailsContent">
                                 Buddy Name: {(registrationInfo.buddy_first_name === null) ? "None" : registrationInfo.buddy_first_name + " " + registrationInfo.buddy_last_name}
                              </div>
                              <div className="RegistrationDetailsDayCampAuthorizedIndividuals">
                                 Authorized Individuals: 
                                 {registrationInfo.day_camp_authorized_individual_one_first_name + " " + registrationInfo.day_camp_authorized_individual_one_last_name}
                                 {registrationInfo.day_camp_authorized_individual_one_relationship}
                                 {registrationInfo.day_camp_authorized_individual_one_phone}
                                 {registrationInfo.day_camp_authorized_individual_two_first_name + " " + registrationInfo.day_camp_authorized_individual_two_last_name}
                                 {registrationInfo.day_camp_authorized_individual_two_relationship}
                                 {registrationInfo.day_camp_authorized_individual_two_phone}
                                 {registrationInfo.day_camp_authorized_individual_three_first_name + " " + registrationInfo.day_camp_authorized_individual_three_last_name}
                                 {registrationInfo.day_camp_authorized_individual_three_relationship}
                                 {registrationInfo.day_camp_authorized_individual_three_phone}
                                 {registrationInfo.day_camp_authorized_individual_four_first_name + " " + registrationInfo.day_camp_authorized_individual_four_last_name}
                                 {registrationInfo.day_camp_authorized_individual_four_relationship}
                                 {registrationInfo.day_camp_authorized_individual_four_phone}
                                 {registrationInfo.day_camp_authorized_individual_five_first_name + " " + registrationInfo.day_camp_authorized_individual_five_last_name}
                                 {registrationInfo.day_camp_authorized_individual_five_relationship}
                                 {registrationInfo.day_camp_authorized_individual_five_phone}
                                 {registrationInfo.day_camp_authorized_individual_six_first_name + " " + registrationInfo.day_camp_authorized_individual_six_last_name}
                                 {registrationInfo.day_camp_authorized_individual_six_relationship}
                                 {registrationInfo.day_camp_authorized_individual_six_phone}
                              </div>
                           </div>
                        }
                        {/* Columns arrive unprefixed here — /getregistrations selects
                            registration.*, unlike the dynamically prefixed select clause that
                            EditRegistrationForm reads from. */}
                        {registrationInfo.camp_type === "Retreat" &&
                           <div className="RegistrationDetailsRetreatDetails">
                              {registrationInfo.room_type === 'deluxe' &&
                                 <div className="RegistrationDetailsRetreatRoomType">
                                    Room Type: Deluxe
                                 </div>
                              }
                              {registrationInfo.camp_name === "Ladies' Retreat" &&
                                 <div className="RegistrationDetailsRetreatCraftFair">
                                    Craft Fair Table: {registrationInfo.craft_fair_table ? "Yes" : "No"}
                                 </div>
                              }
                              {registrationInfo.camp_name === "Couples Retreat" &&
                                 <div className="RegistrationDetailsRetreatSpouse">
                                    Spouse Name: {registrationInfo.spouse_name || "None"}
                                 </div>
                              }
                              {registrationInfo.camp_name === "Father and Son Adventure" &&
                                 <div className="RegistrationDetailsRetreatSons">
                                    Sons ({registrationInfo.father_son_adventure_son_names?.length ?? 0}):{' '}
                                    {registrationInfo.father_son_adventure_son_names?.length > 0
                                       ? registrationInfo.father_son_adventure_son_names.join(", ")
                                       : "None"}
                                 </div>
                              }
                           </div>
                        }
                     </div>
                  }

               </div>
            </div>
            <div className="RegistrationDetailsCloseButtonContainer">
               <button onClick={() => setViewRegistrationVisibility(false)}>
                  Close
               </button>
            </div>
         </div>
      </div>
   )
}
export default RegistrationDetails